exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.system-note-message {\np {\n    display: inline;\n    margin: 0;\n}\na {\n@apply gl-text-link;\n}\n.gfm-project_member {\n    color: var(--gl-link-mention-text-color-default);\n&.current-user {\n      color: var(--gl-link-mention-text-color-current);\n}\n}\n}\n", ""]);

